/**
 * Ajuda dos campos das contrapartes: o endereco, o atendimento e as filiais da
 * seguradora, impressos no documento da apolice (P-MIN-2).
 *
 * Juntada em `../ajudaDosCampos.ts`, que explica a chave e o texto. Ver
 * docs/FRONTEND.md, secao 6.
 */
export const ajuda: Record<string, Record<string, string>> = {
  '/seguradoras': {
    Site: 'Site da seguradora, impresso no rodape do documento da apolice.',
    'Central de atendimento':
      'Telefone da central de atendimento, impresso nas Informacoes importantes da apolice.',
    'Telefone da ouvidoria':
      'Telefone da ouvidoria, impresso nas Informacoes importantes da apolice.',
    'Horario da ouvidoria':
      'Dias e horario da ouvidoria, como devem sair impressos na apolice.',
    'Nome da filial':
      'O que a apolice imprime em FILIAL, em geral a cidade. Nao repete na mesma seguradora.',
    'Codigo da filial': 'Codigo da filial no sistema da seguradora, quando ela tem um.',
    'Situacao da filial':
      'A filial nao e excluida, porque pode estar numa apolice. Inativa, ela nao e oferecida na emissao.',
  },
};
